import { render, staticRenderFns } from "./houseCard.vue?vue&type=template&id=68724842&scoped=true&"
import script from "./houseCard.vue?vue&type=script&lang=js&"
export * from "./houseCard.vue?vue&type=script&lang=js&"
import style0 from "./houseCard.vue?vue&type=style&index=0&id=68724842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68724842",
  null
  
)

component.options.__file = "houseCard.vue"
export default component.exports